import { render, staticRenderFns } from "./AppSteamRedirect.vue?vue&type=template&id=1e549c0c&scoped=true&"
import script from "./AppSteamRedirect.vue?vue&type=script&lang=ts&"
export * from "./AppSteamRedirect.vue?vue&type=script&lang=ts&"
import style0 from "./AppSteamRedirect.vue?vue&type=style&index=0&id=1e549c0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e549c0c",
  null
  
)

export default component.exports